<template>

  <div class="composer-actions d-flex align-items-center">

    <button
      v-for="action in visibleActions"
      :key="action.key"
      type="button"
      class="btn btn-link btn-sm p-0 mr-3"
      :class="action.labelled ? '' : 'text-muted'"
      :title="action.label"
      :disabled="disabled"
      @click="run(action)">
      <i :class="[action.icon, action.labelled ? '' : 'composer-actions-icon']"></i><span v-if="action.labelled">{{ action.label }}</span>
    </button>

    <!-- the attach button owns its own input: no file handling leaks to the parent -->
    <input
      ref="file"
      type="file"
      class="d-none"
      multiple
      :accept="accept"
      @change="onFilesSelected">

  </div>

</template>

<script>
// what the file dialog offers: the medias the channels accept
const ACCEPT = [
  'image/*',
  'video/*',
  'audio/*',
  '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.csv'
].join(',')

export default {
  name: 'ComposerActions',
  props: {
    /*
    what the composer can do right now, in the order the buttons show up.
    the parent decides it from the channel and the session state, eg:
    closed window -> ['template'], open whatsapp window -> everything
    */
    features: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      accept: ACCEPT
    }
  },
  computed: {
    /*
    every action the composer knows about, keyed by feature.
    the key is also the event name emitted when the action is not the attach one
    */
    actions () {
      return {
        attach: { key: 'attach', icon: 'fa-solid fa-paperclip', label: this.$t('Attach files') },
        record: { key: 'record', icon: 'fa-solid fa-microphone', label: this.$t('Record audio') },
        template: { key: 'template', icon: 'fa-solid fa-file-lines mr-1', label: this.$t('Send template'), labelled: true }
      }
    },
    // unknown features are ignored so the parent can pass a raw list
    visibleActions () {
      return this.features
      .map((feature) => { return this.actions[feature] })
      .filter((action) => { return !!action })
    }
  },
  methods: {
    /*
    run
    attach opens the file dialog, every other action just tells the parent
    that something has to be opened (record / template)
    */
    run (action) {
      if (action.key === 'attach') {
        this.openFileDialog()
        return
      }

      this.$emit(action.key)
    },
    /*
    openFileDialog
    */
    openFileDialog () {
      const input = this.$refs.file

      if (!input) {
        return
      }

      // clears the previous pick so choosing the same file fires change again
      input.value = ''
      input.click()
    },
    /*
    onFilesSelected
    hands the chosen files over as a plain array and resets the input
    */
    onFilesSelected (event) {
      const files = Array.prototype.slice.call(event.target.files || [])

      event.target.value = ''

      if (files.length) {
        this.$emit('attach', files)
      }
    }
  }
}
</script>

<style scoped>
.composer-actions .btn {
  line-height: 1;
}

/* icon only buttons are bigger than the ones showing a label */
.composer-actions .composer-actions-icon {
  font-size: 18px;
}

.composer-actions .btn:hover:not(:disabled) {
  color: #2b8aef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/composer/ComposerActions.vue